module.exports = "<h3>Alert</h3>\n<div class=\"text-muted\">alert, confirm的替代</div>\n<section>\n  <div>\n      <pre>\n        <code class=\"language-html\" ng-bind-html=\"vm.exampleHtml\"></code>\n      </pre>\n  </div>\n</section>\n<h3>示例</h3>\n<section>\n  <div class=\"row\">\n    <div class=\"col-xs-4\">\n      <button class=\"btn btn-default\" ng-click=\"myAlert()\">Alert</button>\n      <button class=\"btn btn-default\" ng-click=\"myAlertWithHint()\">Alert with hint</button>\n      <button class=\"btn btn-default\" ng-click=\"myConfirm()\">Confirm</button>\n    </div>\n  </div>\n</section>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./examples/service/alert/template.html
 ** module id = 241
 ** module chunks = 0
 **/